
import * as Common from '@/agiles/common';
// import { BindItem } from '../common/formatter';


export class BatchSchedule extends Common.ObjectBase {
    constructor() {
        super('BatchSchedule');
    }
    public id: number = 0;
    public name: string;
    public queryTypeName: string;
    public scheduleType: number = 0;
    public get scheduleType2():number {
        return this.scheduleType;
    }
    public set scheduleType2(value:number){

            if (value == 0) this.dateFlag = 0;
            else this.dayOfWeekFlag = 0;

        this.scheduleType = value;
    }
    public dateFlag: number = 0;
    public dayOfWeekFlag: number = 0;
    public schedule: Date = new Date(2000, 1, 1, 0, 0);
    public execCount:number = 1;
    public execSpan:number = 0;
    public lastLaunchTime: Date;
    public nextLaunchTime: Date;
    public isRequired:boolean = false;

    public get execCount2() { return this.execCount;}
    public set execCount2(value:number) { this.execCount = value; if (value > 1) this.execSpan = 60; else this.execSpan = 0;}


    public get dateDescription(): string {
        if (this.scheduleType == 0){
            var dayOfWeeks = new Array<string>();
            if ((this.dayOfWeekFlag & 2) != 0) dayOfWeeks.push("月");
            if ((this.dayOfWeekFlag & 4) != 0) dayOfWeeks.push("火");
            if ((this.dayOfWeekFlag & 8) != 0) dayOfWeeks.push("水");         
            if ((this.dayOfWeekFlag & 16) != 0) dayOfWeeks.push("木");         
            if ((this.dayOfWeekFlag & 32) != 0) dayOfWeeks.push("金");         
            if ((this.dayOfWeekFlag & 64) != 0) dayOfWeeks.push("土");
            if ((this.dayOfWeekFlag & 1) != 0) dayOfWeeks.push("日");                     
            return dayOfWeeks.join("・");
        } else {
            return BatchSchedule.getDateFlags().find(obj =>obj.value == this.dateFlag).text;
        }

    }

    public static getDateFlags(): Common.BindItem[] {
        const result = new Array();
        result.push(new Common.BindItem(0,"(未指定)"));
        for(let i = 1;i<=28;i++)
        {
            result.push(new Common.BindItem(i, i +"日"));
        }
        result.push(new Common.BindItem(29,"末日"));
        return result;
    }
    public copy():any {
        const temp = super.copy() as BatchSchedule;
        temp.id = 0;
    　 temp.lastLaunchTime = null;
        temp.nextLaunchTime = undefined;
        return temp;
    }        
}

export class BatchScheduleQuery extends Common.LoadQuery {
    constructor() {
        super('BatchScheduleQuery', BatchSchedule);
        this.sort = 'id';
    }
}

export class BatchLaunchQuery extends Common.Query {
    constructor(batchId:number) {
        super('BatchLaunchQuery', null);
        this.batchId = batchId;
    }    
    public batchId : number = 0;
}